/**
 * Funnel tile (source=events, type=funnel). Backend:
 * { chart: 'funnel', steps: [{event, level, contacts, pct}] }.
 *
 * NOTE: the funnel module is a UMD-wrapped Highcharts factory — a bare
 * side-effect import (`import 'highcharts/modules/funnel'`) does NOT register
 * the funnel series type, the factory must be invoked with Highcharts. Without
 * this call, Highcharts.chart(... {type:'funnel'}) throws and unmounts the
 * whole BoardDetail render.
 */
import React, { useEffect, useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsFunnel from 'highcharts/modules/funnel';

// Initialize once per module load. Idempotent under HMR.
if (typeof HighchartsFunnel === 'function') HighchartsFunnel(Highcharts);

export default function FunnelTile({ data }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !Array.isArray(data?.steps)) return;
    const steps = data.steps;
    Highcharts.chart(ref.current, {
      chart: { type: 'funnel', height: 416, spacing: [12, 12, 12, 12] },
      title: { text: undefined },
      credits: { enabled: false },
      plotOptions: {
        funnel: {
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b><br/>{point.y:,.0f}  ({point.pct}%)',
            style: { fontSize: '11px', textOutline: 'none' },
            softConnector: true,
          },
          neckWidth: '30%',
          neckHeight: '20%',
          width: '70%',
        },
      },
      legend: { enabled: false },
      series: [{
        name: 'Contacts',
        data: steps.map((s) => ({ name: s.event, y: Number(s.contacts), pct: s.pct })),
      }],
    });
  }, [data]);
  return <div ref={ref} style={{ width: '100%', minHeight: 416 }} />;
}
